<template>

  <div class="activities-head-image">
  </div>

</template>
  
<script>
  export default {
    name: 'ActivitiesHeader'
  }
</script>

  
<style scoped>

/* for desktop */
@media (min-width:701px) {

.activities-head-image {
  background-image: url('../assets/ActivitiesHeader.jpg');
  background-size: cover; 
  background-position: center; 
  height: 20vw; 
  display: flex;
  }
}

/* for Phone */
@media (max-width:700px) {

.activities-head-image {
    width: 0rem;
    height: 0rem;
  }  
}
</style>